<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div id="review-of-information" class="qi-content">
        <header>
          <h1 v-if="!successCreate">Revisão das informações</h1>
          <h1 v-else>Criação da pré-matrícula</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row v-if="!successCreate">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
          <SelectedFinancialBox></SelectedFinancialBox>
        </vs-row>

        <vs-row v-if="!successCreate">
          <vs-col>
            <vs-radio
              v-model="typeId"
              vs-name="typeId"
              vs-value="P"
              class="radio"
              >Matrícula Presencial</vs-radio
            >
            <vs-radio
              v-model="typeId"
              vs-name="typeId"
              vs-value="O"
              class="radio"
              >Matrícula Online</vs-radio
            >
          </vs-col>
        </vs-row>

        <vs-card
          class="card-questions"
        >
          <vs-row v-if="!successCreate">
            <h4>PREENCHA AS QUESTÕES ABAIXO:</h4>
            <vs-divider/>
            <div>
              <h4>Qual a data que o cliente tem disponível para fazer a auditoria?</h4>
              <div style="margin-top: 10px;">
                <vs-col style="padding: 3.5px;" v-for="(shifts, index) in dateDisponible" :key="index" class="search">
                  <input style="margin-right: 5px;" type="checkbox" class="checkboxTurn" :id="index" v-model="dateSelected" :value="shifts"/>{{ shifts }}
                </vs-col>
              </div>
            </div>
            <vs-divider/>
            <div>
              <h4>Qual o horário que o cliente tem disponível para fazer a auditoria?</h4>
              <div style="margin-top: 10px; display: flex;">
                <span style="margin-top: 7.5px; margin-right: 8.5px;">Entre</span>
                <vs-select
                  width="100%"
                  v-model="hourSelected"
                  placeholder="00:00hrs - 00:00hrs"
                  @change="findMatriculation()"
                >
                  <vs-select-item
                    :key="index"
                    :value="option.HORAS"
                    :text="option.HORAS"
                    v-for="(option, index) in hourDisponible"
                  />
                </vs-select>
              </div>
            </div>
            <vs-divider/>
            <h4>Cliente tem bolsa ex aluno ou empresa conveniada? Qual?</h4>
            <vs-textarea
              style=" margin-top: 10px;border: 1px solid;"
              v-model="discountStudent"
            />
          </vs-row>
        </vs-card>

        <vs-row
          v-show="errors.lenght > 0"
          vs-w="12"
          style="margin-top: 24px"
          vs-justify="center"
        >
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-alert
              v-for="(error, i) in errors"
              v-bind:key="i"
              color="danger"
              closable
              close-icon="close"
              title="Erros no processo de criação ou avanço de etapa da pré-matrícula"
            >
              {{ error.error }}
            </vs-alert>
          </vs-col>
        </vs-row>
        <vs-row v-if="successCreate">
          <vs-alert
            color="success"
            :active.sync="successCreate"
            close-icon="close"
            title="Geração de Pré-Matrícula"
          >
            <vs-col>
              Pré-matrícula gerada com sucesso!
              <strong>Id: {{ preRegistrationId }}</strong>
              {{ successAdvance }}
              <strong v-if="reEnrollment"
                >Protocolo de rematrícula: {{ stepsData.codAtendimento }}</strong
              >
              <p v-if="successCreate && reEnrollment && RA">
                A secretaria fará a confirmação da sua rematrícula no prazo de até
                3 dias úteis.
              </p>
            </vs-col>
          </vs-alert>
        </vs-row>
        <vs-row>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="account_balance"
                style="width: 100%;"
                @click="backToFinancial()"
                type="filled"
                color="danger"
                v-show="!successCreate"
              >
                Ajustar Etapa Financeira
              </vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="check_circle"
                style="width: 100%;"
                @click="save()"
                type="filled"
                color="success"
                v-if="!successCreate && !edit && !reEnrollment"
              >
                Criar Pré
              </vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="check_circle"
                :color="colorButton"
                style="width: 100%;"
                @click="saveAndGoFoward()"
                type="filled"
                v-bind:text="textButtonGo"
                v-if="!successCreate && !reEnrollment && !edit"
              >
                {{ textButtonGo }}
              </vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="check_circle"
                style="width: 100%;"
                v-if="reEnrollment"
                @click="saveReEnrollmentAndGoFoward()"
                type="filled"
                color="#139B0E"
                v-bind:text="textButtonGo"
                v-show="!successCreate"
              >
                Efetuar Rematrícula
              </vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="search"
                style="width: 100%;"
                @click="requireCoordApprobation()"
                type="filled"
                color="danger"
                v-if="edit && coordApprobation"
              >
                Solicitar Aprovação do Coordenador
              </vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <div>
              <vs-button
                icon="check_circle"
                style="width: 100%;"
                @click="requireCoordApprobation()"
                type="filled"
                color="#139B0E"
                v-if="edit && !coordApprobation"
              >
                Salvar e Reservar Pré
              </vs-button>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import MailingService from "../services/mailing";
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import SelectedFinancialBox from "../components/SelectedFinancialBox.vue";
import PreRegistrationService from "../services/preRegistration.js";
import {
  clearStepsInformation,
  formatDateToLocale,
  formatDateToUSA,
  getLoginDataFromStorage,
  getStepsInformation,
  notifyError,
} from "../helpers";

export default {
  name: "ReviewInformation",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    SelectedFinancialBox,
  },
  data: () => ({
    stepsData: [],
    justSave: false,
    supervisorApprobation: false,
    coordApprobation: false,
    goToSecretary: true,
    successCreate: false,
    successAdvance: null,
    successDisposal: null,
    dateDisponible: null,
    dateSelected: [],
    hourSelected: [],
    hourDisponible: [
      { HORAS: "09:00hrs - 10:00hrs" },
      { HORAS: "10:00hrs - 11:00hrs" },
      { HORAS: "11:00hrs - 12:00hrs" },
      { HORAS: "12:00hrs - 13:00hrs" },
      { HORAS: "13:00hrs - 14:00hrs" },
      { HORAS: "14:00hrs - 15:00hrs" },
      { HORAS: "15:00hrs - 16:00hrs" },
      { HORAS: "16:00hrs - 17:00hrs" },
      { HORAS: "17:00hrs - 18:00hrs" },
      { HORAS: "18:00hrs - 19:00hrs" },
      { HORAS: "19:00hrs - 20:00hrs" },
    ],
    discountStudent: null,
    discussionText: null,
    discussionScreen: null,
    errors: [],
    preRegistrationId: null,
    colorButton: "#139B0E",
    textButtonGo: "Salvar e Reservar Pré",
    edit: false,
    reEnrollment: false,
    RA: null,
    typeId: null,
  }),
  created() {
    this.dateDisponible = this.disponibleDate();
    this.stepsData = getStepsInformation();
    const loginData = getLoginDataFromStorage();
    if (loginData.RA) this.RA = loginData.RA;
    this.reEnrollment = this.stepsData.reEnrollment;
    if (this.stepsData.tax) {
      if (this.stepsData.tax.NIVEL == "S") {
        this.supervisorApprobation = true;
        this.colorButton = "#9B0E1C";
        this.textButtonGo = "Solicitar Aprovação do Supervisor";
        this.goToSecretary = false;
      }
      if (this.stepsData.tax.NIVEL == "C") {
        this.coordApprobation = true;
        this.goToSecretary = false;
      }
    }
    if (this.stepsData.installment) {
      if (this.stepsData.installment.NIVEL == "S") {
        this.supervisorApprobation = true;
        this.colorButton = "#9B0E1C";
        this.textButtonGo = "Solicitar Aprovação do Supervisor";
        this.goToSecretary = false;
      }
      if (this.stepsData.installment.NIVEL == "C") {
        this.coordApprobation = true;
        this.goToSecretary = false;
      }
    }
    this.edit = this.stepsData.edit;
  },
  methods: {
    disponibleDate() {
      const dataAtual = new Date();
      const arrayDeDatas = [];

      for (let i = 0; i < 6; i++) {
        const data = new Date(dataAtual);
        data.setDate(dataAtual.getDate() + i);
        arrayDeDatas.push(formatDateToLocale(data.toISOString().split('T')[0]));
      }

      return arrayDeDatas;
    },

    backToFinancial() {
      this.reEnrollment
        ? this.$router.push("/payment")
        : this.$router.push("/tax");
    },

    async save() {
      this.justSave = true;
      this.goToSecretary = false;
      await this.saveAndGoFoward();
    },

    async createPreRegistration(preRegistration) {
      await new PreRegistrationService()
        .create(preRegistration)
        .then((res) => {
          if (res.status == "200") this.successCreate = true;
        })
        .catch((error) => {
          this.successCreate = false;
          console.log("1: " + error);
          this.errors.push({ error: error.response.data.error });
        });
    },

    async getPreRegistrationId() {
      await new PreRegistrationService()
        .searchByAttendance(
          1,
          this.stepsData.codLocal,
          this.stepsData.codAtendimento
        )
        .then((res) => {
          this.preRegistrationId = res.data.IDPREMATRICULA;
        })
        .catch((error) => {
          console.log("2: " + error);
          this.errors.push(error);
        });
    },

    async disposal(preRegistrationIdRel) {
      const pre = {
        idDisposalReason: "0",
        coligateId: "1",
        RELANCADA: "1",
      };
      if (this.preRegistrationId) {
        await new PreRegistrationService()
          .disposal(pre, preRegistrationIdRel)
          .then((res) => {
            if (res.status == "200") this.successDisposal = true;
          })
          .catch((error) => {
            console.log("3: " + error);
            this.errors.push(error);
          });
      } else {
        this.errors.push({
          error:
            "Não foi possível descartar a pré pois não foi localizado o id da mesma",
        });
      }
    },

    async cancel() {
      clearStepsInformation();
    },

    async requireCoordApprobation() {
      if (!this.typeId) {
        notifyError(this, "Selecione o tipo de matrícula");
        return false;
      }
      if (this.dateSelected == "") {
        notifyError(this, "Informe a data em que o cliente tem disponibilidade!");
        return false;
      }
      if (this.hourSelected == "") {
        notifyError(this, "Informe o horário em que o cliente tem disponibilidade!");
        return false;
      }
      if (!this.discountStudent) {
        notifyError(this, "Informe se o cliente possui bolsas de ex aluno ou empresa conveniada!");
        return false;
      }


      if (this.dateSelected != "" && this.hourSelected != "" && this.discountStudent != null) {
        this.discussionText =
          'Qual a data disponível para o cliente fazer a auditoria? ' + this.dateSelected +
          '\nQual o horário que o cliente tem disponível para fazer a auditoria? Entre ' + this.hourSelected +
          '\nCliente tem bolsa ex aluno ou empresa conveniada? Qual? ' + this.discountStudent;
        new MailingService()
        .updateDiscussion(
          this.discussionText,
          this.stepsData.codAtendimento,
          this.stepsData.codLocal,
          this.stepsData.codColigada
        ).then(({ data }) => {
          this.discussionScreen = data;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data;
            console.log(response);
          }
        });
      }

      this.$vs.loading({
        color: "danger",
      });

      this.successAdvance = null;
      this.preRegistrationId = this.stepsData.preRegistration.IDPREMATRICULA;
      this.errors = [];

      const preRegistration = this.mountEditPreRegistrationObject();

      let level = "V";
      if (this.stepsData.tax) {
        if (this.stepsData.tax.NIVEL == "S") {
          level = "S";
        } else if (this.stepsData.tax.NIVEL == "C") {
          level = "C";
        }
      }

      if (this.stepsData.installment) {
        if (this.stepsData.installment.NIVEL == "S") {
          level = "S";
        } else if (this.stepsData.installment.NIVEL == "C") {
          level = "C";
        }
      }

      if (this.stepsData.scholarshipSelected) {
        if (this.stepsData.scholarshipSelected.NIVEL == "S") {
          level = "S";
        } else if (this.stepsData.scholarshipSelected.NIVEL == "C") {
          level = "C";
        }
      }
      await this.createPreRegistration(preRegistration);

      if (this.successCreate) {
        await this.advance("SE", level);
        if (this.successAdvance) {
          if (this.coordApprobation)
            this.successAdvance =
              "Encaminhada para aprovação do supervisor/coordenador.";
          else
            this.successAdvance = "Aguardando Pagamento da Taxa de Matrícula.";
          this.coordApprobation = false;
          this.goToSecretary = false;
          this.edit = false;
          clearStepsInformation();
        }
      }

      this.$vs.loading.close();
    },

    async advance(type, level) {
      const pre = {
        colligateCod: "1",
        localCod: this.stepsData.codLocal,
        nivel: level,
        attendanceCod: this.stepsData.codAtendimento,
        type: type,
      };
      if (this.preRegistrationId) {
        await new PreRegistrationService()
          .advance(pre, this.preRegistrationId)
          .then((res) => {
            if (res.status == "200") this.successAdvance = true;
          })
          .catch((error) => {
            this.successAdvance = false;
            console.log("4: " + error.response.data.error);
            this.errors.push({ error: error.response.data.error });
            console.log(this.errors);
          });
      } else {
        this.errors.push({
          error:
            "Não foi possível avançar etapa pois não foi localizado o id da pré-matrícula",
        });
      }
    },

    async saveAndGoFoward() {
      if (!this.typeId) {
        notifyError(this, "Selecione o tipo de matrícula");
        return false;
      }
      if (this.dateSelected == "") {
        notifyError(this, "Informe a data em que o cliente tem disponibilidade!");
        return false;
      }
      if (this.hourSelected == "") {
        notifyError(this, "Informe o horário em que o cliente tem disponibilidade!");
        return false;
      }
      if (!this.discountStudent) {
        notifyError(this, "Informe se o cliente possui bolsas de ex aluno ou empresa conveniada!");
        return false;
      }

      if (this.dateSelected != "" && this.hourSelected != "" && this.discountStudent != null) {
        this.discussionText =
          'Qual a data disponível para o cliente fazer a auditoria? ' + this.dateSelected +
          '\nQual o horário que o cliente tem disponível para fazer a auditoria? Entre ' + this.hourSelected +
          '\nCliente tem bolsa ex aluno ou empresa conveniada? Qual? ' + this.discountStudent;
        new MailingService()
        .updateDiscussion(
          this.discussionText,
          this.stepsData.codAtendimento,
          this.stepsData.codLocal,
          this.stepsData.codColigada
        ).then(({ data }) => {
          this.discussionScreen = data;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data;
            console.log(response);
          }
        });
      }

      this.$vs.loading({
        color: "danger",
      });

      this.successCreate = null;
      this.successAdvance = null;
      this.preRegistrationId = null;
      this.errors = [];

      const preRegistration = this.mountPreRegistrationObject();

      let level = "V";
      if (
        this.stepsData.tax.NIVEL == "S" ||
        this.stepsData.installment.NIVEL == "S"
      )
        level = "S";

      if (
        this.stepsData.tax.NIVEL == "C" ||
        this.stepsData.installment.NIVEL == "C"
      )
        level = "C";

      if (this.stepsData.scholarshipSelected) {
        if (this.stepsData.scholarshipSelected.NIVEL == "S") {
          level = "S";
        } else if (this.stepsData.scholarshipSelected.NIVEL == "C") {
          level = "C";
        }
      }

      await this.createPreRegistration(preRegistration);
      if (this.successCreate) {
        await this.getPreRegistrationId();
        if (preRegistration.preRegistrationIdRel != "-1")
          await this.disposal(preRegistration.preRegistrationIdRel);

        await this.advance("CR", level);
        if (this.successAdvance && !this.justSave)
          await this.advance("SE", level);
      }
      if (
        this.successAdvance &&
        (this.supervisorApprobation || this.coordApprobation)
      )
        this.successAdvance =
          "Encaminhada para aprovação do supervisor/coordenador.";
      if (this.successAdvance && this.goToSecretary)
        this.successAdvance = "Aguardando pagamento da taxa de matrícula.";
      if (this.successAdvance && this.justSave)
        this.successAdvance = "Pré Matrícula salva com sucesso.";

      this.$vs.loading.close();
      clearStepsInformation();
    },

    mountPreRegistrationObject() {
      var objScholarships = [];
      if (this.stepsData.scholarship) {
        objScholarships.push({
          id: this.stepsData.scholarship.IDBOLSA,
          initialParcel: this.stepsData.scholarship.PARCELAINI,
          finalParcel: this.stepsData.scholarship.PARCELAFIM,
          discount: this.stepsData.scholarship.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarship.CODBOLSA,
          type: this.stepsData.scholarship.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipExternal) {
        objScholarships.push({
          id: this.stepsData.scholarshipExternal.IDBOLSA,
          initialParcel: this.stepsData.scholarshipExternal.PARCELAINI,
          finalParcel: this.stepsData.scholarshipExternal.PARCELAFIM,
          discount: this.stepsData.scholarshipExternal.scholarshipPercentExternal,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipExternal.CODBOLSA,
          type: this.stepsData.scholarshipExternal.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipCritical) {
        objScholarships.push({
          id: this.stepsData.scholarshipCritical.IDBOLSA,
          initialParcel: this.stepsData.scholarshipCritical.PARCELAINI,
          finalParcel: this.stepsData.scholarshipCritical.PARCELAFIM,
          discount: this.stepsData.scholarshipCritical.scholarshipPercentCritical,
          idCritical: this.stepsData.scholarshipCritical.IDBOLSATURMACRITICA,
          codBolsa: this.stepsData.scholarshipCritical.CODBOLSA,
          type: this.stepsData.scholarshipCritical.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipException) {
        objScholarships.push({
          id: this.stepsData.scholarshipException.IDBOLSA,
          initialParcel: this.stepsData.scholarshipException.PARCELAINI,
          finalParcel: this.stepsData.scholarshipException.PARCELAFIM,
          discount: this.stepsData.scholarshipException.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipException.CODBOLSA,
          type: this.stepsData.scholarshipException.TIPOBOLSA,
        });
      }

      let subjects = [];
      this.stepsData.subjects.forEach((element) => {
        subjects.push({
          id: element.IDTURMADISC,
        });
      });

      if (this.stepsData.scholarshipByAttendance) {
        objScholarships.push({
          id: this.stepsData.scholarshipByAttendance.IDBOLSAATENDIMENTO,
          initialParcel: this.stepsData.scholarshipByAttendance.PARCELAINI,
          finalParcel: this.stepsData.scholarshipByAttendance.PARCELAFIM,
          discount: this.stepsData.scholarshipByAttendance.PERCENTUAL,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipByAttendance.CODBOLSA,
          type: this.stepsData.scholarshipByAttendance.TIPOBOLSA,
        });
      }
      let campus = this.stepsData.offer.CODCAMPUS
        ? this.stepsData.offer.CODCAMPUS
        : -1;
      var obj = {
        preRegistrationIdRel: this.stepsData.preRegistrationIdRel
          ? this.stepsData.preRegistrationIdRel
          : "-1",
        colligateCod: this.stepsData.offer.CODCOLIGADA,
        branchCod: this.stepsData.offer.CODFILIAL,
        branchQualificationId: this.stepsData.offer.IDHABILITACAOFILIAL,
        ra: this.stepsData.student.RA,
        colCFOCod: this.stepsData.client.CODCOLCFO,
        campus: campus,
        hasFinancial: true,
        attendanceCod: this.stepsData.codAtendimento,
        fcfoCod: this.stepsData.client.CODCFO,
        classificationId: this.stepsData.course.IDCLASSIFICACAO,
        localCod: this.stepsData.codLocal,
        courseTypeCod: this.stepsData.classData.CODTIPOCURSO,
        entranceExamTime: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.entranceExamTime
          : "",
        entranceExamDate: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.entranceExamDate
          : "",
        registrationType: "",
        admissionTypeCod: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.CODTIPOINGRESSO
          : "",
        financial: {
          parcelValue:
            this.stepsData.course.VALOR /
            this.stepsData.installment.numberOfInstallments,
          parcelTotal: this.stepsData.installment.numberOfInstallments,
          feeAmount: this.stepsData.tax.VALORBRUTO,
          discountRate: this.stepsData.tax.DESCONTO,
          paymentMethod: this.stepsData.payment.IDFORMAPGTO,
          paymentMethodFee: this.stepsData.taxPayment.IDFORMAPGTO,
          dueDateFee: formatDateToUSA(this.stepsData.tax.dueDate),
          dueDateParcel: formatDateToUSA(this.stepsData.installment.dueDate),
          secondDueDateParcel: formatDateToUSA(
            this.stepsData.installment.secondDueDate
          ),
          parcelCourseId: this.stepsData.installment.IDPARCELAMENTO,
          descadim: this.stepsData.payment.PERCDESC,
          courseFeeId: this.stepsData.tax.IDTAXA,
          feeType: this.stepsData.tax.TIPOTAXA,
          parcelType: this.stepsData.installment.TIPOPARC,
          idLanReaTx: this.stepsData.tax.idLanReaTx ? this.stepsData.tax.idLanReaTx : "-1",
        },
        typeId: this.typeId,
        scholarships: objScholarships,
        subjects: subjects,
      };
      return obj;
    },

    mountEditPreRegistrationObject() {
      var objScholarships = [];
      if (this.stepsData.scholarship) {
        objScholarships.push({
          id: this.stepsData.scholarship.IDBOLSA,
          initialParcel: this.stepsData.scholarship.PARCELAINI,
          finalParcel: this.stepsData.scholarship.PARCELAFIM,
          discount: this.stepsData.scholarship.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarship.CODBOLSA,
          type: this.stepsData.scholarship.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipExternal) {
        objScholarships.push({
          id: this.stepsData.scholarshipExternal.IDBOLSA,
          initialParcel: this.stepsData.scholarshipExternal.PARCELAINI,
          finalParcel: this.stepsData.scholarshipExternal.PARCELAFIM,
          discount: this.stepsData.scholarshipExternal.scholarshipPercentExternal,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipExternal.CODBOLSA,
          type: this.stepsData.scholarshipExternal.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipCritical) {
        objScholarships.push({
          id: this.stepsData.scholarshipCritical.IDBOLSA,
          initialParcel: this.stepsData.scholarshipCritical.PARCELAINI,
          finalParcel: this.stepsData.scholarshipCritical.PARCELAFIM,
          discount: this.stepsData.scholarshipCritical.scholarshipPercentCritical,
          idCritical: this.stepsData.scholarshipCritical.IDBOLSATURMACRITICA,
          codBolsa: this.stepsData.scholarshipCritical.CODBOLSA,
          type: this.stepsData.scholarshipCritical.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipException) {
        objScholarships.push({
          id: this.stepsData.scholarshipException.IDBOLSA,
          initialParcel: this.stepsData.scholarshipException.PARCELAINI,
          finalParcel: this.stepsData.scholarshipException.PARCELAFIM,
          discount: this.stepsData.scholarshipException.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipException.CODBOLSA,
          type: this.stepsData.scholarshipException.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipByAttendance) {
        objScholarships.push({
          id: this.stepsData.scholarshipByAttendance.IDBOLSAATENDIMENTO,
          initialParcel: this.stepsData.scholarshipByAttendance.PARCELAINI,
          finalParcel: this.stepsData.scholarshipByAttendance.PARCELAFIM,
          discount: this.stepsData.scholarshipByAttendance.PERCENTUAL,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipByAttendance.CODBOLSA,
          type: this.stepsData.scholarshipByAttendance.TIPOBOLSA,
        });
      }
      let campus = this.stepsData.preRegistration.CODCAMPUS
        ? this.stepsData.preRegistration.CODCAMPUS
        : -1;
      let parcelValue = 0;
      if (this.stepsData.installment) {
        parcelValue =
          (Number(this.stepsData.preRegistration.VALORPARCELA) *
            Number(this.stepsData.preRegistration.NUMPARCELA)) /
          this.stepsData.installment.numberOfInstallments;
        parcelValue = parcelValue.toFixed(2);
      } else {
        parcelValue = this.stepsData.preRegistration.VALORPARCELA;
      }
      var obj = {
        preRegistrationId: this.preRegistrationId,
        preRegistrationIdRel: this.stepsData.preRegistrationIdRel
          ? this.stepsData.preRegistrationIdRel
          : "-1",
        colligateCod: this.stepsData.preRegistration.CODCOLIGADA,
        branchCod: this.stepsData.preRegistration.CODFILIAL,
        branchQualificationId:
          this.stepsData.preRegistration.IDHABILITACAOFILIAL,
        ra: this.stepsData.preRegistration.RA,
        colCFOCod: this.stepsData.preRegistration.CODCOLCFO,
        campus: campus,
        hasFinancial: true,
        attendanceCod: this.stepsData.preRegistration.CODATENDIMENTO,
        fcfoCod: this.stepsData.preRegistration.CODFCFO,
        classificationId: this.stepsData.preRegistration.IDCLASSIFICACAO,
        localCod: this.stepsData.preRegistration.CODLOCAL,
        courseTypeCod: this.stepsData.preRegistration.CODTIPOCURSO,
        entranceExamTime: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.entranceExamTime
          : "",
        entranceExamDate: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.entranceExamDate
          : "",
        registrationType: "",
        admissionTypeCod: this.stepsData.admissionMode
          ? this.stepsData.admissionMode.CODTIPOINGRESSO
          : "",
        financial: {
          parcelValue: parcelValue,
          parcelTotal: this.stepsData.installment
            ? this.stepsData.installment.numberOfInstallments
            : this.stepsData.preRegistration.NUMPARCELA,
          feeAmount: this.stepsData.tax
            ? this.stepsData.tax.VALORBRUTO
            : this.stepsData.preRegistration.VALORTAXA,
          discountRate: this.stepsData.tax
            ? this.stepsData.tax.DESCONTO
            : this.stepsData.preRegistration.DESCONTOTAXA,
          paymentMethod: this.stepsData.payment
            ? this.stepsData.payment.IDFORMAPGTO
            : this.stepsData.preRegistration.FORMAPAGTO,
          paymentMethodFee: this.stepsData.taxPayment
            ? this.stepsData.taxPayment.IDFORMAPGTO
            : this.stepsData.preRegistration.FORMAPAGTOTX,
          dueDateFee: this.stepsData.tax
            ? formatDateToUSA(this.stepsData.tax.dueDate)
            : this.stepsData.preRegistration.DTVENCIMENTOTAXA,
          dueDateParcel: this.stepsData.installment
            ? formatDateToUSA(this.stepsData.installment.dueDate)
            : this.stepsData.preRegistration.DTVENCIMENTOPARC,
          secondDueDateParcel: this.stepsData.installment
            ? formatDateToUSA(this.stepsData.installment.secondDueDate)
            : this.stepsData.preRegistration.DTVENCIMENTOPARC2,
          parcelCourseId: this.stepsData.installment
            ? this.stepsData.installment.IDPARCELAMENTO
            : this.stepsData.preRegistration.IDPARCCURSO,
          descadim: this.stepsData.payment
            ? this.stepsData.payment.PERCDESC
            : this.stepsData.preRegistration.DESCADIM,
          courseFeeId: this.stepsData.tax
            ? this.stepsData.tax.IDTAXA
            : this.stepsData.preRegistration.IDTAXACURSO,
          feeType: this.stepsData.tax
            ? this.stepsData.tax.TIPOTAXA
            : this.stepsData.preRegistration.TIPOTAXA,
          parcelType: this.stepsData.installment
            ? this.stepsData.installment.TIPOPARC
            : this.stepsData.preRegistration.TIPOPARC,
          idLanReaTx: this.stepsData.tax && this.stepsData.tax.idLanReaTx ? this.stepsData.tax.idLanReaTx : "-1",  
        },
        typeId: this.typeId,
        scholarships: objScholarships,
      };

      return obj;
    },

    async saveReEnrollmentAndGoFoward() {
      if (!this.typeId) {
        notifyError(this, "Selecione o tipo de matrícula");
        return false;
      }

      if (this.dateSelected != "" && this.hourSelected != "" && this.discountStudent != null) {
        this.discussionText =
          'Qual a data disponível para o cliente fazer a auditoria? ' + this.dateSelected +
          '\nQual o horário que o cliente tem disponível para fazer a auditoria? Entre ' + this.hourSelected +
          '\nCliente tem bolsa ex aluno ou empresa conveniada? Qual? ' + this.discountStudent;
        new MailingService()
        .updateDiscussion(
          this.discussionText,
          this.stepsData.codAtendimento,
          this.stepsData.codLocal,
          this.stepsData.codColigada
        ).then(({ data }) => {
          this.discussionScreen = data;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data;
            console.log(response);
          }
        });
      }

      this.$vs.loading({
        color: "danger",
      });

      this.successCreate = null;
      this.successAdvance = null;
      this.preRegistrationId = null;
      this.errors = [];

      const preRegistration = this.mountPreReEnrollmentRegistrationObject();

      let level = "V";
      if (this.stepsData.installment.NIVEL == "S") level = "S";

      if (this.stepsData.installment.NIVEL == "C") level = "C";

      if (this.stepsData.scholarshipSelected) {
        if (this.stepsData.scholarshipSelected.NIVEL == "S") {
          level = "S";
        } else if (this.stepsData.scholarshipSelected.NIVEL == "C") {
          level = "C";
        }
      }

      await this.createPreRegistration(preRegistration);
      if (this.successCreate) {
        await this.getPreRegistrationId();
        if (preRegistration.preRegistrationIdRel != "-1")
          await this.disposal(preRegistration.preRegistrationIdRel);

        await this.advance("CR", level);
        if (this.successAdvance) await this.advance("RE", level);
      }
      if (this.successAdvance && this.supervisorApprobation)
        this.successAdvance =
          "Encaminhada para aprovação do supervisor/coordenador.";
      if (this.successAdvance && this.goToSecretary)
        this.successAdvance =
          "Pré-matrícula encaminhada para secretaria, aguardando confirmação.";
      this.$vs.loading.close();
      clearStepsInformation();
    },

    mountPreReEnrollmentRegistrationObject() {
      var objScholarships = [];
      if (this.stepsData.scholarship) {
        objScholarships.push({
          id: this.stepsData.scholarship.IDBOLSA,
          initialParcel: this.stepsData.scholarship.PARCELAINI,
          finalParcel: this.stepsData.scholarship.PARCELAFIM,
          discount: this.stepsData.scholarship.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarship.CODBOLSA,
          type: this.stepsData.scholarship.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipExternal) {
        objScholarships.push({
          id: this.stepsData.scholarshipExternal.IDBOLSA,
          initialParcel: this.stepsData.scholarshipExternal.PARCELAINI,
          finalParcel: this.stepsData.scholarshipExternal.PARCELAFIM,
          discount: this.stepsData.scholarshipExternal.scholarshipPercentExternal,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipExternal.CODBOLSA,
          type: this.stepsData.scholarshipExternal.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipCritical) {
        objScholarships.push({
          id: this.stepsData.scholarshipCritical.IDBOLSA,
          initialParcel: this.stepsData.scholarshipCritical.PARCELAINI,
          finalParcel: this.stepsData.scholarshipCritical.PARCELAFIM,
          discount: this.stepsData.scholarshipCritical.scholarshipPercentCritical,
          idCritical: this.stepsData.scholarshipCritical.IDBOLSATURMACRITICA,
          codBolsa: this.stepsData.scholarshipCritical.CODBOLSA,
          type: this.stepsData.scholarshipCritical.TIPOBOLSA,
        });
      }

      if (this.stepsData.scholarshipException) {
        objScholarships.push({
          id: this.stepsData.scholarshipException.IDBOLSA,
          initialParcel: this.stepsData.scholarshipException.PARCELAINI,
          finalParcel: this.stepsData.scholarshipException.PARCELAFIM,
          discount: this.stepsData.scholarshipException.scholarshipPercent,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipException.CODBOLSA,
          type: this.stepsData.scholarshipException.TIPOBOLSA,
        });
      }

      let subjects = [];
      this.stepsData.subjects.forEach((element) => {
        subjects.push({
          id: element.IDTURMADISC,
        });
      });

      if (this.stepsData.scholarshipByAttendance) {
        objScholarships.push({
          id: this.stepsData.scholarshipByAttendance.IDBOLSAATENDIMENTO,
          initialParcel: this.stepsData.scholarshipByAttendance.PARCELAINI,
          finalParcel: this.stepsData.scholarshipByAttendance.PARCELAFIM,
          discount: this.stepsData.scholarshipByAttendance.PERCENTUAL,
          idCritical: '0',
          codBolsa: this.stepsData.scholarshipByAttendance.CODBOLSA,
          type: this.stepsData.scholarshipByAttendance.TIPOBOLSA,
        });
      }

      let campus =
        this.stepsData.offer.CODCAMPUS != "0"
          ? this.stepsData.offer.CODCAMPUS
          : "-1";

      var obj = {
        preRegistrationIdRel: "-1",
        colligateCod: this.stepsData.offer.CODCOLIGADA,
        branchCod: this.stepsData.offer.CODFILIAL,
        branchQualificationId: this.stepsData.offer.IDHABILITACAOFILIAL,
        ra: this.stepsData.course.RA,
        colCFOCod: this.stepsData.client.CODCOLCFO,
        campus: campus,
        hasFinancial: true,
        attendanceCod: this.stepsData.codAtendimento,
        fcfoCod: this.stepsData.client.CODCFO,
        classificationId: this.stepsData.offer.IDCLASSIFICACAO,
        localCod: this.stepsData.codLocal,
        courseTypeCod: this.stepsData.classData.CODTIPOCURSO,
        entranceExamTime: "",
        entranceExamDate: "",
        registrationType: "",
        admissionTypeCod: "",
        financial: {
          parcelValue:
            this.stepsData.offer.VALOR /
            this.stepsData.installment.numberOfInstallments,
          parcelTotal: this.stepsData.installment.numberOfInstallments,
          feeAmount: "-1",
          discountRate: "-1",
          paymentMethod: this.stepsData.payment.IDFORMAPGTO,
          paymentMethodFee: "",

          dueDateFee: "",

          dueDateParcel: formatDateToUSA(this.stepsData.installment.dueDate),
          secondDueDateParcel: formatDateToUSA(
            this.stepsData.installment.secondDueDate
          ),
          parcelCourseId: this.stepsData.installment.IDPARCELAMENTO,
          descadim: this.stepsData.payment.PERCDESC,
          courseFeeId: "-1",
          feeType: "-1",
          parcelType: this.stepsData.installment.TIPOPARC,
          idLanReaTx: this.stepsData.tax && this.stepsData.tax.idLanReaTx ? this.stepsData.tax.idLanReaTx : "-1",
        },
        typeId: this.typeId,
        scholarships: objScholarships,
        subjects: subjects,
      };
      return obj;
    },
  },
};
</script>
<style scoped>
.reset-alert-height > div {
  height: initial !important;
}
.radio {
  float: left;
  margin-right: 1em;
}
.card-questions{
  padding: 5px;
  margin: 7.5px;
  width: 98.25%;
}
</style>
